/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import React from "react";
import { TextFieldWithCount } from "components/text-field/text-field";
import CategoryTitle from "components/category-title/category-title";
import PushNotificationTargets from "pages/content/push-notification/components/push-notification-targets/push-notification-targets";
import { Target } from "api/push-notification";
import { t } from "i18n";

const PushNotifications = ({
  story,
  fieldLimits,
  onPushNotificationTextChange,
  onPushNotificationTargetChange,
  onPushNotificationTitleChange,
  channelsEnabled,
  disabled
}) => {
  const targets: Target[] = story["push-notification-targets"] || [];

  return (
    <React.Fragment>
      <CategoryTitle title={t("story-editor.inspector.push-notification")} />
      <TextFieldWithCount
        label={t("story-editor.inspector.push-notification-title")}
        value={story["push-notification-title"]}
        disabled={story["is-published"] || disabled}
        maxValue={fieldLimits["push-notification"] && fieldLimits["push-notification"].limit}
        onChange={(val) => onPushNotificationTitleChange(val)}
      />
      <TextFieldWithCount
        label={t("story-editor.inspector.push-notification-message")}
        value={story["push-notification"]}
        disabled={story["is-published"] || disabled}
        maxValue={fieldLimits["push-notification"] && fieldLimits["push-notification"].limit}
        onChange={(val) => onPushNotificationTextChange(val)}
      />
      {!story["is-published"] && (
        <PushNotificationTargets
          targets={targets}
          channelsEnabled={channelsEnabled}
          onUpdate={(targets) => onPushNotificationTargetChange(targets)}
          disabled={disabled}
        />
      )}
    </React.Fragment>
  );
};

export default PushNotifications;
